import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

require('./relations-indicator.scss');
@Component({
  standalone: false,
  selector: 'app-relations-indicator',
  templateUrl: './relations-indicator.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class RelationsIndicatorComponent  {

  @Input() count: any;

  constructor() {
  }


}
